import React from 'react'
import { Modal, Row, Col, ButtonToolbar, ButtonGroup } from 'react-bootstrap'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Icon from './icon'
import TopTooltip from './topTooltip'
import { Link } from 'react-router'
import postForm from '_/utils/postForm'
import getImageData from '_/utils/getImageData'

/**
 * Bottom navigation component
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class ResultDetailModal extends React.Component {
  static propTypes = {
    docIds: React.PropTypes.object,
    propertyId: React.PropTypes.string,
    type: React.PropTypes.string,
    transactionId: React.PropTypes.string,
    transactions: React.PropTypes.object,
    onCheck: React.PropTypes.func.isRequired,
    onModalClose: React.PropTypes.func.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      isChecked: false,
      isLockDisabled: false,
      isPrintDisabled: false,
      active: false
    }
  }

  async componentWillReceiveProps (props) {
    if (!props.transactionId) return

    if (this.props.transactionId !== props.transactionId) {
      const data = await this.returnTransactionDetails(props.transactionId)

      this.setState({
        active: true,
        isChecked: props.docIds.indexOf(props.transactionId) !== -1,
        propId: props.propertyId,
        ...data
      })
    }
    else {
      const { currentId } = this.state
      this.setState({
        isChecked: props.docIds.indexOf(currentId) !== -1
      })
    }
  }

  returnTransactionType () {
    const { type } = this.props

    const types = {
      Sale   : 'sales',
      Lease  : 'leases',
      IncExp : 'incexps',
      Const  : 'consts'
    }

    return types[type]
  }

  async returnTransactionDetails (id) {
    const { docIds, transactions } = this.props
    const { store } = this.context

    const transaction = transactions.get('data').find(t => t.get('id') === id)
    const transactionIds = transactions.get('data').map(t => t.get('id'))

    const type = this.returnTransactionType()

    const markup = await store.get(`~/${type}/${id}/detail`)
    const parts = markup.split('~---BREAK---~')
    const idx = transactionIds.findIndex(v => v === id)

    const re = /<div class="detail-section"><h5><b>[^<]+?<\/b><\/h5><table class="table table-bordered table-condensed"><tbody><\/tbody><\/table><\/div>/g

    const unlockVal = parts[0].match(/<b>(.*?)<\/b>/g) || []

    this.setState({
      prevId: idx - 1 >= 0 && transactionIds.get(idx - 1),
      nextId: idx + 1 >= 1 && transactionIds.get(idx + 1),
      isChecked: docIds.indexOf(id) !== -1,
      isLockDisabled: false,
      footerMarkup: parts[1],
      cssMarkup: parts[2],
      bodyMarkup: parts[3].replace(re, ''),
      currentId: id,
      unlockVal: unlockVal.length ? unlockVal[0].replace(/<\/?b>/g,'') : '',
      propId: transaction.getIn(['properties', 0, 'id'])
    })
  }

  async showWindow (evt) {
    evt.preventDefault()

    this.setState({ active: true })

    const { currentId } = this.state
    await this.returnTransactionDetails(currentId)
  }

  hideWindow () {
    const { onModalClose } = this.props
    this.setState({
      isChecked: false,
      isLockDisabled: false,
      isPrintDisabled: false,
      active: false,
      footerMarkup: undefined,
      cssMarkup: undefined,
      bodyMarkup: undefined,
      currentId: undefined,
      propId: undefined,
      prevId: undefined,
      nextId: undefined
    })
    onModalClose()
  }

  handleCheck (evt) {
    evt.preventDefault()

    const { onCheck } = this.props
    const { currentId } = this.state
    onCheck(currentId)
  }

  async handleUnlock (evt) {
    evt.preventDefault()

    this.setState({
      isLockDisabled: true
    })

    const { store } = this.context
    const { currentId } = this.state
    const type = this.returnTransactionType()

    await store.get(`~/${type}/${currentId}/unlock-all?isModal=true`)
    await this.returnTransactionDetails(currentId)
  }

  async handlePrev (evt) {
    evt.preventDefault()

    const { prevId } = this.state
    await this.returnTransactionDetails(prevId)
  }

  async handleNext (evt) {
    evt.preventDefault()

    const { nextId } = this.state
    await this.returnTransactionDetails(nextId)
  }

  async handlePrint (evt) {
    evt.preventDefault()
    const { bodyMarkup, cssMarkup } = this.state
    this.setState({isPrintDisabled: true})

    const srcRe = /src=("\/[^<]+?")/g
    let body = bodyMarkup
    const imgs = body.match(srcRe)

    if (imgs && imgs.length) {
      await Promise.all(imgs.map(async src => {
        const srcStrRe = /src="(.*?)"/

        let srcStr = srcStrRe.exec(src)[1]
        if (srcStr.indexOf('exhibits') !== -1) {
          srcStr = srcStr.split('.')[0]
        }

        const imgData = await getImageData(`/api/v1${srcStr}`)
        body = body.replace(src, `src="${imgData}"`)
      }))
    }

    postForm('/pdf', {
      name: 'Summary report',
      html: cssMarkup + body.replace('mapSize=415,300', 'mapSize=465,300'),
      footer: '<p align="center"><small>{{page}} of {{pages}}</small></p>',
    })

    this.setState({isPrintDisabled: false})
  }

  render() {
    const { type } = this.props
    const {
      active,
      prevId,
      nextId,
      currentId,
      propId,
      isChecked,
      isLockDisabled,
      isPrintDisabled,
      footerMarkup,
      bodyMarkup,
      unlockVal
    } = this.state

    if (!active) return null

    const isPrevDisabled = !prevId
    const isNextDisabled = !nextId

    return (
      <Modal show={active} bsSize="large" onHide={::this.hideWindow}>
        <Modal.Header closeButton={false}>
          <Row>
            <Col xs={8} xsOffset={4}>
              <button className="close" onClick={::this.hideWindow}>&times;</button>
              <div style={{ paddingRight: '20px' }} className="pull-right">
                <ButtonToolbar>
                  <ButtonGroup>
                    {unlockVal &&
                      <TopTooltip content={`Unlock this transaction and all properties for ${unlockVal} points.`}>
                        <a href="#" className={`btn btn-lg text-success ${isLockDisabled && 'disabled'}`}  onClick={::this.handleUnlock}>
                          <Icon name="fa-lock text-success" /> {unlockVal}
                        </a>
                      </TopTooltip>
                    }
                    <a href="#" className="btn btn-lg text-danger" onClick={::this.handleCheck}>
                      <Icon name={isChecked ? 'fa-check-square-o' : 'fa-square-o'} />
                    </a>
                    <a href="#" className={`btn btn-lg text-info ${isPrevDisabled && 'disabled'}`} onClick={::this.handlePrev}>
                      <Icon name="fa-arrow-left" />
                    </a>
                    <a href="#" className={`btn btn-lg text-info ${isNextDisabled && 'disabled'}`} onClick={::this.handleNext}>
                      <Icon name="fa-arrow-right" />
                    </a>
                    <a href="#" className={`btn btn-lg text-warning ${isPrintDisabled && 'disabled'}`} onClick={::this.handlePrint}>
                      <Icon name="fa-print" />
                    </a>
                    <TopTooltip content="View detailed">
                      <Link
                        className="btn btn-lg text-primary"
                        to={type.toLowerCase()}
                        params={{id: propId, transId: currentId}}>
                        <Icon name="fa-file-text-o" />
                      </Link>
                    </TopTooltip>
                  </ButtonGroup>
                </ButtonToolbar>
              </div>
            </Col>
          </Row>
        </Modal.Header>

        <Modal.Body className="redi-listing-modal-body">
          <div dangerouslySetInnerHTML={{__html: bodyMarkup}} />
        </Modal.Body>

        <Modal.Footer className="redi-listing-modal-footer">
          <div dangerouslySetInnerHTML={{__html: footerMarkup }} />
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ResultDetailModal



// WEBPACK FOOTER //
// ./modules/shared/components/resultDetailModal.js